import React, { Suspense, useState } from 'react';
import { Switch, Route, Redirect, BrowserRouter } from 'react-router-dom';

import { UserContext } from '../store/userContext';
import { SplashScreen } from 'src/components/SplashScreen';
import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { ErrorPage } from 'insidesistemas-error-pages/dist/pages/ErrorPage';

import AuthRoute from './AuthRoute';

const ViewerPreview = React.lazy(async () => import('../pages/ViewerPreview'));

const viewerFixturesEnabled = process.env.REACT_APP_VIEWER_FIXTURES === 'true';
const LoginPage = React.lazy(async () => import('../pages/Login'));
const Dashboard = React.lazy(async () => import('../pages/Dashboard'));
const Designer = React.lazy(async () => import('../pages/Designer'));
const Permissions = React.lazy(async () => import('../pages/Permissions'));
const Publications = React.lazy(async () => import('../pages/Publications'));
const Store = React.lazy(async () => import('../pages/Store'));

function Routes() {
  const [user, setUser] = useState({});

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <ErrorBoundary>
        <Suspense fallback={<SplashScreen />}>
          <BrowserRouter>
            <Switch>
              <Route path="/login" component={LoginPage} />
              <AuthRoute path="/" exact auth component={Dashboard} redirect="/login" />
              <AuthRoute path="/permissions" exact auth component={Permissions} redirect="/login" />
              <AuthRoute
                path="/publications"
                exact
                auth
                component={Publications}
                redirect="/login"
              />
              <AuthRoute path="/store" exact auth component={Store} redirect="/login" />
              <AuthRoute path="/designer" exact auth component={Designer} redirect="/login" />
              {viewerFixturesEnabled && (
                <AuthRoute
                  path="/viewer-preview"
                  exact
                  auth
                  component={ViewerPreview}
                  redirect="/login"
                />
              )}
              <Route path="/error-page" exact component={ErrorPage} />
              <Route
                path="*"
                exact
                component={(props: any) => (
                  <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                )}
              />
            </Switch>
          </BrowserRouter>
        </Suspense>
      </ErrorBoundary>
    </UserContext.Provider>
  );
}

export default Routes;
